var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,{tag:"Component",attrs:{"data":_vm.data,"donut":true}})}
var staticRenderFns = []

export { render, staticRenderFns }